import React from "react";
import { GlobalButton, GlobalTextField } from "../../../../../global/forms/GlobalFormFields";
import { updateMaintenanceRequest } from "../../../api/maintenanceApi";
import "../../../styles/maintenance/MaintenanceFormModal.css";
import OfficeStaffAssignTypeahead from "../OfficeStaffAssignTypeahead";

function formatDate(dateString) {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString();
}

function getStatusLabel(statusId) {
  const labels = {
    1: "Pending",
    2: "In Progress",
    3: "Completed",
    4: "Cancelled",
  };
  return labels[statusId] || "Unknown";
}

export default function MaintenanceRequestModalsSection({
  masters,
  onNotify,
  showViewForm,
  selectedRequest,
  onCloseViewForm,
  showAssignForm,
  onCloseAssignForm,
  selectedRequestForAssign,
  setSelectedRequestForAssign,
  onRequestUpdated,
}) {
  const assignedDisplayName = (req) => {
    const id = String(req?.assigned_to || "");
    return (
      req?.assigned_to_name ||
      masters?.users?.find((u) => String(u.id) === id)?.name ||
      "Unassigned"
    );
  };

  return (
    <>
      {showViewForm && selectedRequest ? (
        <div className="maintenance-form-overlay">
          <div className="maintenance-form-modal">
            <div className="maintenance-form-header">
              <h3>View maintenance request</h3>
              <GlobalButton onClick={onCloseViewForm} variant="ghost" ariaLabel="Close">
                ×
              </GlobalButton>
            </div>
            <div className="maintenance-form-content">
              <GlobalTextField label="Request ID" value={`#${selectedRequest.id}`} disabled />
              <GlobalTextField
                label="Date"
                value={formatDate(selectedRequest.created_at)}
                disabled
              />
              <GlobalTextField label="Maintenance type" value={selectedRequest.type} disabled />
              <GlobalTextField label="Asset / area" value={selectedRequest.asset_area} disabled />
              <GlobalTextField label="Reported by" value={selectedRequest.reported_by} disabled />
              <GlobalTextField
                label="Assigned to (who does the work)"
                value={assignedDisplayName(selectedRequest)}
                disabled
              />
              <GlobalTextField
                label="Status"
                value={
                  selectedRequest.status || getStatusLabel(selectedRequest.status_id)
                }
                disabled
              />
              <GlobalTextField
                label="Cost"
                value={
                  selectedRequest.cost_incurred != null && selectedRequest.cost_incurred !== ""
                    ? `₹${Number(selectedRequest.cost_incurred).toFixed(2)}`
                    : "N/A"
                }
                disabled
              />
              {selectedRequest.attachment &&
              String(selectedRequest.attachment).trim() !== "" ? (
                <p className="gff-field gff-field--full" style={{ margin: 0 }}>
                  <span className="gff-label">Attachment</span>
                  <a
                    href={String(selectedRequest.attachment).trim()}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="gff-input"
                    style={{ display: "inline-block", padding: "0.5rem 0" }}
                  >
                    Open file
                  </a>
                </p>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}

      {showAssignForm && selectedRequestForAssign ? (
        <div className="maintenance-form-overlay">
          <div className="maintenance-form-modal">
            <div className="maintenance-form-header">
              <h3>Assign staff</h3>
              <GlobalButton onClick={onCloseAssignForm} variant="ghost" ariaLabel="Close">
                ×
              </GlobalButton>
            </div>
            <div className="maintenance-form-content">
              <GlobalTextField label="Request ID" value={`#${selectedRequestForAssign.id}`} disabled />
              <GlobalTextField
                label="Asset / area"
                value={selectedRequestForAssign.asset_area}
                disabled
              />
              <OfficeStaffAssignTypeahead
                userId={String(selectedRequestForAssign.assigned_to || "")}
                displayName={selectedRequestForAssign.assigned_to_name || ""}
                onChange={(id, name) =>
                  setSelectedRequestForAssign((prev) => ({
                    ...prev,
                    assigned_to: id,
                    assigned_to_name: name,
                  }))
                }
                label="Assign to"
              />
            </div>
            <div className="maintenance-form-actions">
              <GlobalButton onClick={onCloseAssignForm} variant="ghost">
                Cancel
              </GlobalButton>
              <GlobalButton
                variant="primary"
                onClick={async () => {
                  try {
                    await updateMaintenanceRequest(selectedRequestForAssign.id, {
                      assigned_to: selectedRequestForAssign.assigned_to,
                    });
                    onNotify("Staff assigned successfully!");
                    onCloseAssignForm();
                    onRequestUpdated();
                  } catch (error) {
                    onNotify(error.message || "Failed to assign staff", {
                      variant: "error",
                    });
                  }
                }}
              >
                Assign staff
              </GlobalButton>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
